import logger from '../../services/logging/logging-service';

const CARD_1_CLASS = ['c-card', 'c-card--CA10-m', 'c-card--CA15-t', 'c-card--CA10-d'];
const CARD_234_CLASS = ['c-card', 'c-card--CA05C-m', 'c-card--CA15-t', 'c-card--CA15-d'];
const HIDDEN_CLASS = ['u-hidden-m', 'u-hidden-t', 'u-hidden-d'];

const CURREN_PAGE_URL = window.location.href.split('?')[0];
const linkArray = [];

const otherNews = document.querySelectorAll('.j-other-news .c-card') || null;
const card4 = document.querySelector('.j-other-news-card-4') || null;
const card1 = document.querySelector('.j-other-news-card-1') || null;

export const init = () => {
  if (otherNews) {
    otherNews.forEach((ele) => linkArray.push(ele.href));
    const duplicateNewsIndex = linkArray.indexOf(`${CURREN_PAGE_URL}`);

    if ([0, 1, 2, 3].includes(duplicateNewsIndex)) {
      document.querySelector(`.j-other-news-card-${duplicateNewsIndex}`).remove();
      card4 ? card4.classList.remove(...HIDDEN_CLASS) : null;
    }
    if (duplicateNewsIndex === 0 && card1) {
      card1.classList.remove(...CARD_234_CLASS);
      card1.classList.add(...CARD_1_CLASS);
    }
  }
  logger.info('Start initOtherNewsChecker.');
};
